export const LoadingDots = () => (
  <div className="flex items-center justify-center space-x-2 py-2">
    <div className="size-2 animate-pulse rounded-full bg-gray-400"></div>
    <div className="size-2 animate-pulse rounded-full bg-gray-400 delay-150"></div>
    <div className="size-2 animate-pulse rounded-full bg-gray-400 delay-300"></div>
  </div>
);
